import { useState } from "react";
import { Avatar } from "../_shared/avatar";
import {
  IconArrowRight,
  IconCamera,
  IconChevronLeft,
  IconPlus,
} from "../_shared/icons";
import { back } from "../_shared/router";
import { chatThread } from "../_data/mock";

export function ChatPage() {
  const [draft, setDraft] = useState("");

  return (
    <div className="flex h-dvh flex-col">
      <header className="sticky top-0 z-10 flex items-center gap-3 border-b border-[var(--border-1)] bg-[var(--overlay-frost)] px-3 pb-2.5 pt-[calc(env(safe-area-inset-top)+0.625rem)] backdrop-blur">
        <button
          type="button"
          onClick={back}
          aria-label="Retour"
          className="inline-flex size-10 items-center justify-center rounded-full text-[var(--text-2)] transition hover:bg-[var(--surface-2)] active:scale-95"
        >
          <IconChevronLeft width={24} height={24} strokeWidth={2.5} />
        </button>
        <Avatar
          initials={chatThread.initials}
          photoUrl={chatThread.photoUrl}
          alt={chatThread.contactName}
          tone="gray"
          size="lg"
        />
        <div className="min-w-0 flex-1">
          <p className="truncate text-[15px] font-semibold text-[var(--text-1)]">
            {chatThread.contactName}
          </p>
          <p className="truncate text-[11.5px] text-[var(--text-2)]">
            {chatThread.contactRole}
          </p>
        </div>
      </header>

      <div className="flex-1 overflow-y-auto px-4 py-4">
        <ul className="mx-auto flex max-w-2xl flex-col gap-1.5">
          {chatThread.messages.map((m, i) => {
            const prev = chatThread.messages[i - 1];
            const showTime = !prev || prev.at !== m.at;
            const mine = m.from === "me";
            return (
              <li key={m.id} className="flex flex-col">
                {showTime ? (
                  <p className="my-2 text-center text-[11px] font-medium text-[var(--text-3)]">
                    {m.at}
                  </p>
                ) : null}
                <div
                  className={`flex ${mine ? "justify-end" : "justify-start"}`}
                >
                  <div
                    className={`max-w-[80%] rounded-2xl px-3.5 py-2.5 text-[14.5px] leading-snug shadow-sm sm:max-w-[70%] ${
                      mine
                        ? "rounded-br-sm bg-[var(--sf-primary)] text-white"
                        : "rounded-bl-sm bg-[var(--surface-1)] text-[var(--text-1)] ring-1 ring-[var(--border-1)]"
                    }`}
                  >
                    {m.text}
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="sticky bottom-0 border-t border-[var(--border-1)] bg-[var(--surface-1)] px-3 py-2 pb-[max(env(safe-area-inset-bottom),0.5rem)]">
        <div className="mx-auto flex max-w-2xl items-end gap-2">
          <button
            type="button"
            aria-label="Joindre une photo"
            className="inline-flex size-11 shrink-0 items-center justify-center rounded-full bg-[var(--surface-2)] text-[var(--text-2)] transition hover:bg-[var(--surface-3)] active:scale-95"
          >
            <IconCamera width={20} height={20} />
          </button>
          <button
            type="button"
            aria-label="Joindre un fichier"
            className="inline-flex size-11 shrink-0 items-center justify-center rounded-full bg-[var(--surface-2)] text-[var(--text-2)] transition hover:bg-[var(--surface-3)] active:scale-95"
          >
            <IconPlus width={20} height={20} />
          </button>
          <div className="flex min-w-0 flex-1 items-end gap-2 rounded-3xl bg-[var(--surface-2)] px-3 py-2">
            <textarea
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              rows={1}
              placeholder="Message…"
              className="block min-h-7 w-full resize-none bg-transparent text-[15px] outline-none placeholder:text-[var(--text-3)]"
            />
          </div>
          <button
            type="button"
            disabled={!draft.trim()}
            aria-label="Envoyer"
            className="inline-flex size-11 shrink-0 items-center justify-center rounded-full bg-[var(--sf-primary)] text-white shadow-sm transition active:scale-95 disabled:cursor-not-allowed disabled:bg-[var(--surface-3)] disabled:text-[var(--text-3)]"
          >
            <IconArrowRight width={18} height={18} strokeWidth={2.2} />
          </button>
        </div>
      </div>
    </div>
  );
}
